import {MedicalCenterModel} from "src/app/core/models/medical-center.model";


export class SetMedicalCenterMetadata {
  static readonly type = '[MedicalCenter] Set Medicalcenter Metadata';

  constructor(public readonly payload: MedicalCenterModel) {
  }
}
